import { Row } from '@/components';
import { FunctionComponent } from 'react';

type MobileCardProps = {
  items: Array<string | null | number | JSX.Element>;
};

export const UserCard: FunctionComponent<MobileCardProps> = ({ items }) => {
  return (
    <div className="border border-[#E9E9E9] rounded-lg py-[15px] px-[20px] shadow-[0px_4px_4px_rgba(0,0,0,0.2)] flex justify-between">
      <div className="flex flex-col">
        <>{items[0]}</>
        <Row align="center" gap={8}>
          <div> {items[1]}</div>
          <div>¿Pagado?</div> <div>{items[2]}</div>
        </Row>
        <Row align="center" gap={8}>
          <div>¿Asistió?</div> {items[3]}
        </Row>
      </div>
      <div>{items[4]}</div>
    </div>
  );
};
